module.exports = __webpack_public_path__ + "img/Ministere_PTNTIC.899086ed.png";